import Author from './author';
import Benefits from './benefits';
import BlogPost from './blog-post';
import ContentSlider from './content-slider';
import Cta from './cta';
import CustomerIoLeadForm from './customer-io-lead-form';
import EducationalDiscount from './educational-discount';
import FaqSection from './faq-section';
import HeaderWithPromo from './header-with-promo';
import Ingredients from './ingredients';
import IngredientsGrid from './ingredients-grid';
import PersonioIframe from './personio-iframe';
import ProductSlider from './product-slider';
import PromoBar from './promo-bar';
import SingleProductPanel from './single-product-panel';
import Slider from './slider';
import Subscription from './subscription';
import Text from './text';
import TextImageCombo from './text-image-combo';
import Typeform from './typeform';
import Video from './video';

type ContentType =
  | typeof Benefits
  | typeof Ingredients
  | typeof Subscription
  | typeof ContentSlider
  | typeof Cta
  | typeof Typeform
  | typeof IngredientsGrid
  | typeof Text
  | typeof TextImageCombo
  | typeof Slider
  | typeof Video
  | typeof HeaderWithPromo
  | typeof CustomerIoLeadForm
  | typeof EducationalDiscount
  | typeof FaqSection
  | typeof PersonioIframe
  | typeof ProductSlider
  | typeof SingleProductPanel
  | typeof BlogPost
  | typeof PromoBar
  | typeof Author;

const sections: {
  [key: string]: ContentType;
} = {
  SectionBenefits: Benefits,
  SectionIngredients: Ingredients,
  SectionSubscription: Subscription,
  SectionContentSlider: ContentSlider,
  SectionCta: Cta,
  SectionTypeform: Typeform,
  SectionIngredientsGrid: IngredientsGrid,
  SectionText: Text,
  SectionTextimageCombo: TextImageCombo,
  Sectionslider: Slider,
  SectionVideo: Video,
  HeaderWithPromo: HeaderWithPromo,
  SectionCustomerIoLeadForm: CustomerIoLeadForm,
  SectionEducationalDiscount: EducationalDiscount,
  SectionFaQs: FaqSection,
  SectionPersonioIframe: PersonioIframe,
  SectionProductSlider: ProductSlider,
  SingleProductPanel: SingleProductPanel,
  BlogPost: BlogPost,
  PromoBar: PromoBar,
  Author: Author,
};

export default sections;
